import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { setPermissions } from '@s20/slices/features/permissions.slice';
import { getAllPermissions } from '@s20/selectors/features/permissions.selectors';
import { history } from '@s20/store';
import { getLocation } from '@s20/selectors/helpers/router.selectors';
import { httpClient } from '@s20/services/httpClient';
import JobTypeIndex from './components/jobType/JobTypeIndex';
import CacheBuster from './CacheBuster';
// Routing
import { Layout } from './components/Layout';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
// Permissions
import { AbilityContext } from './components/Can';
import { ApiRoutes, AppNavPaths } from './components/Common';
import defineAbilityFor from './AppAbility';
// Style
import './style/App.scss';
// Components
import BillingIndex from './components/billing/BillingIndex';
import BillingIssuesIndex from './components/billingIssues/BillingIssuesIndex';
import DispatchIssuesIndex from './components/dispatchIssues/DispatchIssuesIndex';
import BillingChargeCategoryIndex from './components/billingChargeCategory/BillingChargeCategoryIndex';
import BillingChargeIndex from './components/billingCharge/BillingChargeIndex';
import BillingRateIndex from './components/billing/BillingRateIndex';
import InvoiceIndex from './components/invoice/InvoiceIndex';
import InvoiceGenerationIndex from './components/invoiceGeneration/InvoiceGenerationIndex';
import ChargeViewIndex from './components/chargeView/ChargeViewIndex';
import ChargeTypeForm from './components/chargeType/ChargeTypeForm';
import ChargeTypeIndex from './components/chargeType/ChargeTypeIndex';
import ChargeTypeGroupForm from './components/chargeTypeGroup/ChargeTypeGroupForm';
import ChargeTypeGroupIndex from './components/chargeTypeGroup/ChargeTypeGroupIndex';
import ContractForm from './components/contracts/ContractForm';
import CompanyBillingGroupIndex from './components/companyBillingGroup/CompanyBillingGroupIndex';
import CompanyBillingGroupForm from './components/companyBillingGroup/CompanyBillingGroupForm';
import PayScheduleIndex from './components/paySchedule/PayScheduleIndex';
import PayScheduleForm from './components/paySchedule/PayScheduleForm';
import ContractIndex from './components/contracts/ContractIndex';
import EmployeeForm from './components/employee/EmployeeForm';
import EmployeeIndex from './components/employee/EmployeeIndex';
import EquipmentIndex from './components/equipment/EquipmentIndex';
import EquipmentTypeIndex from './components/equipment/EquipmentTypeIndex';
import GroupIndex from './components/group/GroupIndex';
import GroupForm from './components/group/GroupForm';
import UserGroupIndex from './components/userGroup/UserGroupIndex';
import UserGroupForm from './components/userGroup/UserGroupForm';
import RoleIndex from './components/role/RoleIndex';
import RoleForm from './components/role/RoleForm';
import JobIndex from './components/job/JobIndex';
import JobForm from './components/job/JobForm';
import OrganizationIndex from './components/organization/OrganizationIndex';
import OrganizationForm from './components/organization/OrganizationForm';
import authService from './components/api-authorization/AuthorizeService';
import Dashboard from './Dashboard';
import DispatchBoard from './components/dispatch/DispatchBoard';
import AssignmentCalendar from './components/assignmentCalendar/AssignmentCalendar';
import TimeCharge from './components/timeCharge/TimeCharge';
import TimeOffRequest from './components/timeOffRequest/TimeOffRequest';
import Timesheet from './components/timesheet/TimesheetForm';
import MyTimesheets from './components/timesheet/MyTimesheets';
import TimesheetManagementIndex from './components/timesheetManagement/TimesheetManagementIndex';
import AssignmentConfirmation from './components/assignmentConfirmation/AssignmentConfirmation';
import CancelConfirmation from './components/cancelConfirmation/CancelConfirmation';
import PayrollIndex from './components/payroll/PayrollIndex';
import PayrollIndividualIndex from './components/payroll/PayrollIndividualIndex';
import PayrollManagementIndex from './components/payrollManagement/PayrollManagementIndex';
import { NotFound } from './components/api-authorization/NotFound';
import TenantIndex from './components/tenant/TenantIndex';
import TenantForm from './components/tenant/TenantForm';
import { ServerError } from './components/api-authorization/ServerError';
import { NotAuthorizedPage } from './components/status/StatusCodes';
import { NoPermission } from './components/api-authorization/NoPermission';
import ContractTemplateIndex from './components/contractTemplate/ContractTemplateIndex';
import ContractTemplateForm from './components/contractTemplate/ContractTemplateForm';
import DailyJobView from './components/job/DailyJobView';
import DailyRosterView from './components/employee/DailyRosterView';
import SelfDispatchTimesheetForm from './components/timesheet/SelfDispatchTimesheetForm';
import ContactIndex from './components/contact/ContactIndex';
import ContactActivityIndex from './components/contactActivity/ContactActivityIndex';
import CallDispositionIndex from './components/callDisposition/CallDispositionIndex';
import QuickBooksInventoryItemsIndex from './components/QuickBooksInventoryItems/QuickBooksInventoryItemsIndex';
import QuickBooksInventoryItemsForm from './components/QuickBooksInventoryItems/QuickBooksInventoryItemForm';
import LongTermStatusIndex from './components/longTermStatus/LongTermStatusIndex';
import DailyAttendanceEventIndex from './components/dailyAttendanceEvent/DailyAttendanceEventIndex';
import JobAssignmentCancellationTypeIndex from './components/jobAssignmentCancellationType/JobAssignmentCancellationTypeIndex';
import ActiveEmployeeListIndex from './components/employee/ActiveEmployeeListIndex';
import CollectedReportingIndex from './components/collectedReporting/CollectedReportingIndex';
import AdminToolIndex from './components/Admin/AdminToolIndex';
import USCountyGroupsIndex from './components/uscounties/USCountyGroupsIndex';
import USCountyGroupForm from './components/uscounties/USCountyGroupForm';
import CrewTimesheet from './components/timesheet/CrewTimesheet';
import { AdminTools } from './components/Admin/AdminTools';
import { SupportTools } from './components/Admin/SupportTools.jsx';
import USStates from './components/uscounties/USStateIndex';
import USStateForm from './components/uscounties/USStateForm';
import EstimateIndex from './components/estimate/EstimateIndex';
import JotFormIndex from './components/jotForm/JotFormIndex';
import JotFormForm from './components/jotForm/JotFormForm';
import JotFormThankYou from './components/jotForm/JotFormThankYou';
import ProjectForm from './components/projectManager/ProjectForm';
import ProjectIndex from './components/projectManager/ProjectIndex';
import CertificationIndex from './components/certification/CertificationIndex';
import CertificationForm from './components/certification/CertificationForm';
import EquipmentTagIndex from './components/equipmentTag/EquipmentTagIndex';
import EquipmentTagForm from './components/equipmentTag/EquipmentTagForm';
import OperationalCategoriesIndex from './components/operationalCategory/OperationalCategoriesIndex';
import OperationalCategoryForm from './components/operationalCategory/OperationalCategoryForm';
import DelegateIndex from './components/delegate/DelegateIndex';
import DelegateForm from './components/delegate/DelegateForm';
import QuickSalesIndex from './components/quickSales/QuickSalesIndex';
import ResourceKitForm from './components/resourceKit/ResourceKitForm';
import ResourceKitIndex from './components/resourceKit/ResourceKitIndex';
import TimeTracker from './components/timeTracker/TimeTracker';
import CalendarJobs from './components/calendarJobs/CalendarJobs';
import { DispatchPlus } from './components/dispatchPlus';
import DispatchGroupIndex from './components/dispatchGroup/DispatchGroupIndex';
import DispatchGroupForm from './components/dispatchGroup/DispatchGroupForm';

const beforeUnload = (e) => e.stopImmediatePropagation();

class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);

        this.layoutRef = React.createRef();
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();

        // https://stackoverflow.com/a/45373907
        this.unlisten = history.listen(() => {
            if (this.layoutRef && this.layoutRef.current) {
                this.layoutRef.current.setFormOpened(false);
            }
        });

        window.addEventListener('beforeunload', beforeUnload);
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
        this.unlisten();

        window.removeEventListener('beforeunload', beforeUnload);
    }

    populateState = async () => {
        const { dispatch } = this.props;
        const isAuthenticated = await authService.isAuthenticated();

        // When auth'd, populate the permissions.
        // Used in ability permissions context app-wide, starting with Routes below.
        if (isAuthenticated) {
            // .catch so a stale OIDC token (server-side 401 while authService
            // still has the cached identity) doesn't surface as an uncaught
            // rejection and trip the dev error overlay.
            const permissions = await httpClient.js(ApiRoutes.auth.permissions()).catch(() => []);
            dispatch(setPermissions(permissions ?? []));
        } else {
            dispatch(setPermissions([]));
        }
    };

    render() {
        const { permissions } = this.props;

        return (
            <CacheBuster>
                {({
                    loading,
                    isLatestVersion,
                    refreshCacheAndReload,
                    currentVersion,
                }) => {
                    if (loading) {
                        return null;
                    }

                    if (!loading && !isLatestVersion) {
                        refreshCacheAndReload(currentVersion);
                    }

                    return (
                        <AbilityContext.Provider
                            value={defineAbilityFor(permissions)}
                        >
                            <Layout version={currentVersion}>
                                <Switch location={this.props.location}>
                                    <AuthorizeRoute
                                        exact
                                        path="/"
                                        component={Dashboard}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="selfdispatchtimesheet"
                                        action="create"
                                        path={`${AppNavPaths.SelfDispatchTimesheetNew}`}
                                        component={
                                            SelfDispatchTimesheetForm
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="selfdispatchtimesheet"
                                        action="view"
                                        path={`${AppNavPaths.SelfDispatchTimesheet}/:id`}
                                        component={
                                            SelfDispatchTimesheetForm
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="timesheet"
                                        action="view"
                                        path={`${AppNavPaths.EmployeeTimesheets}`}
                                        component={MyTimesheets}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="timesheet"
                                        action="view"
                                        path={`${AppNavPaths.CrewTimesheet}/:timesheetId/:employeeId`}
                                        component={CrewTimesheet}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="nonflaggingtimesheet"
                                        action="create"
                                        path={`${AppNavPaths.NonFlaggingTimesheetNew}`}
                                        component={
                                            SelfDispatchTimesheetForm
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="nonflaggingtimesheet"
                                        action="view"
                                        path={`${AppNavPaths.NonFlaggingTimesheet}/:id`}
                                        component={
                                            SelfDispatchTimesheetForm
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billing"
                                        action="view"
                                        path={`${AppNavPaths.Billing}`}
                                        component={BillingIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billing"
                                        action="view"
                                        path={`${AppNavPaths.BillingChargeCategory}`}
                                        component={
                                            BillingChargeCategoryIndex
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billing"
                                        action="view"
                                        path={`${AppNavPaths.BillingCharge}`}
                                        component={BillingChargeIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billing"
                                        action="view"
                                        path={`${AppNavPaths.BillingRate}`}
                                        component={BillingRateIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="chargetype"
                                        action="view"
                                        path={`${AppNavPaths.ChargeType}/:id`}
                                        component={ChargeTypeForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="chargetype"
                                        action="create"
                                        path={`${AppNavPaths.ChargeTypeNew}`}
                                        component={ChargeTypeForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="chargetype"
                                        action="view"
                                        path={`${AppNavPaths.ChargeTypes}`}
                                        component={ChargeTypeIndex}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="chargetype"
                                        action="create"
                                        path={`${AppNavPaths.ChargeTypeGroupNew}`}
                                        component={ChargeTypeGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="chargetype"
                                        action="view"
                                        path={`${AppNavPaths.ChargeTypeGroup}/:id`}
                                        component={ChargeTypeGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="chargetype"
                                        action="view"
                                        path={`${AppNavPaths.ChargeTypeGroups}`}
                                        component={ChargeTypeGroupIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="longtermstatus"
                                        action="view"
                                        path={`${AppNavPaths.LongTermStatuses}`}
                                        component={LongTermStatusIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="dailyattendanceevent"
                                        action="view"
                                        path={`${AppNavPaths.DailyAttendanceEvents}`}
                                        component={
                                            DailyAttendanceEventIndex
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="location_contact"
                                        action="view"
                                        path={`${AppNavPaths.Contacts}`}
                                        component={ContactIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="contract"
                                        action="view"
                                        path={`${AppNavPaths.Contract}/:id`}
                                        component={ContractForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="contract"
                                        action="create"
                                        path={`${AppNavPaths.ContractNew}`}
                                        component={ContractForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="contract"
                                        action="view"
                                        path={`${AppNavPaths.Contracts}`}
                                        component={ContractIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="contract_template"
                                        action="view"
                                        path={`${AppNavPaths.ContractTemplate}/:id`}
                                        component={ContractTemplateForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="contract_template"
                                        action="view"
                                        path={`${AppNavPaths.ContractTemplateIndex}`}
                                        component={ContractTemplateIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="contract_template"
                                        action="create"
                                        path={`${AppNavPaths.ContractTemplateNew}`}
                                        component={ContractTemplateForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="employee"
                                        action="view"
                                        path={`${AppNavPaths.Employee}/:id`}
                                        component={EmployeeForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="employee"
                                        action="create"
                                        path={`${AppNavPaths.EmployeeNew}`}
                                        component={EmployeeForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="employee"
                                        action="view"
                                        path={`${AppNavPaths.Employees}`}
                                        component={EmployeeIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="employee"
                                        action="view"
                                        path={`${AppNavPaths.Delegates}`}
                                        component={DelegateIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="employee"
                                        action="add"
                                        path={`${AppNavPaths.DelegateNew}`}
                                        component={DelegateForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="employee"
                                        action="delete"
                                        path={`${AppNavPaths.Delegate}/:id`}
                                        component={DelegateForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="employee_daily_roster"
                                        action="view"
                                        path={`${AppNavPaths.EmployeeDailyRoster}`}
                                        component={DailyRosterView}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="equipment"
                                        action="view"
                                        path={`${AppNavPaths.Equipment}`}
                                        component={EquipmentIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="equipmenttype"
                                        action="view"
                                        path={`${AppNavPaths.EquipmentTypes}`}
                                        component={EquipmentTypeIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="group"
                                        action="view"
                                        path={`${AppNavPaths.Groups}`}
                                        component={GroupIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="group"
                                        action="view"
                                        path={`${AppNavPaths.Group}/:id`}
                                        component={GroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="group"
                                        action="create"
                                        path={`${AppNavPaths.GroupNew}`}
                                        component={GroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="invoice"
                                        action="view"
                                        path={`${AppNavPaths.Invoice}`}
                                        component={InvoiceIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="rental_invoice"
                                        action="view"
                                        path={`${AppNavPaths.RentalInvoice}`}
                                        component={InvoiceIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="invoice"
                                        action="view"
                                        path={`${AppNavPaths.InvoiceGeneration}`}
                                        component={InvoiceGenerationIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billing_issues"
                                        action="view"
                                        path={`${AppNavPaths.BillingIssues}`}
                                        component={BillingIssuesIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="dispatch_issues"
                                        action="view"
                                        path={`${AppNavPaths.DispatchIssues}`}
                                        component={DispatchIssuesIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="user_group"
                                        action="view"
                                        path={`${AppNavPaths.UserGroups}`}
                                        component={UserGroupIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="user_group"
                                        action="view"
                                        path={`${AppNavPaths.UserGroup}/:id`}
                                        component={UserGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="user_group"
                                        action="create"
                                        path={`${AppNavPaths.UserGroupNew}`}
                                        component={UserGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="role"
                                        action="view"
                                        path={`${AppNavPaths.Roles}`}
                                        component={RoleIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="role"
                                        action="view"
                                        path={`${AppNavPaths.Role}/:id`}
                                        component={RoleForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="role"
                                        action="create"
                                        path={`${AppNavPaths.RoleNew}`}
                                        component={RoleForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="job"
                                        action="view"
                                        path={`${AppNavPaths.Projects}`}
                                        component={ProjectIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="job"
                                        action="view"
                                        path={`${AppNavPaths.ProjectNew}/:contractId`}
                                        component={ProjectForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="job"
                                        action="view"
                                        path={`${AppNavPaths.Project}/:id`}
                                        component={ProjectForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="job"
                                        action="view"
                                        path={`${AppNavPaths.Jobs}`}
                                        component={JobIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="job"
                                        action="view"
                                        path={`${AppNavPaths.Job}/:id`}
                                        component={JobForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="job"
                                        action="create"
                                        path={`${AppNavPaths.JobNew}/:contractId`}
                                        component={JobForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="job_daily_view"
                                        action="view"
                                        path={`${AppNavPaths.JobView}`}
                                        component={DailyJobView}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="location"
                                        action="view"
                                        path={`${AppNavPaths.Organizations}`}
                                        component={OrganizationIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="location"
                                        action="view"
                                        path={`${AppNavPaths.Organization}/:id`}
                                        component={OrganizationForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="location"
                                        action="create"
                                        path={`${AppNavPaths.OrganizationNew}`}
                                        component={OrganizationForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="dispatch"
                                        action="view"
                                        path={`${AppNavPaths.Dispatch}`}
                                        component={DispatchBoard}
                                    />
                                    <AuthorizeRoute
                                        perm="dispatch_plus"
                                        action="view"
                                        path={`${AppNavPaths.DispatchPlus}`}
                                        component={DispatchPlus}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="dispatch_group"
                                        action="view"
                                        path={`${AppNavPaths.DispatchGroups}`}
                                        component={DispatchGroupIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="dispatch_group"
                                        action="create"
                                        path={`${AppNavPaths.DispatchGroupNew}`}
                                        component={DispatchGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="dispatch_group"
                                        action="edit"
                                        path={`${AppNavPaths.DispatchGroup}/:id`}
                                        component={DispatchGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="calendar"
                                        action="view"
                                        path={`${AppNavPaths.AssignmentCalendar}`}
                                        component={AssignmentCalendar}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jobcalendar"
                                        action="view"
                                        path={`${AppNavPaths.CalendarJobs}`}
                                        component={CalendarJobs}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="timesheet"
                                        action="view"
                                        path={`${AppNavPaths.AssignmentConfirmation}/:id`}
                                        component={AssignmentConfirmation}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="timesheet"
                                        action="view"
                                        path={`${AppNavPaths.CancelConfirmation}/:id`}
                                        component={CancelConfirmation}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="dispatch_review"
                                        action="view"
                                        path={`${AppNavPaths.TimesheetManagement}`}
                                        component={TimesheetManagementIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="charge_view"
                                        action="view"
                                        path={`${AppNavPaths.ChargeView}`}
                                        component={ChargeViewIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="tenant"
                                        action="edit"
                                        path={`${AppNavPaths.Tenants}`}
                                        component={TenantIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="tenant"
                                        action="edit"
                                        path={`${AppNavPaths.Tenant}/:id`}
                                        component={TenantForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="timesheet"
                                        action="view"
                                        path={[`${AppNavPaths.Timesheet}/:id`, `${AppNavPaths.Timesheet}/:id/:assignmentId`]}
                                        component={Timesheet}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="timesheet"
                                        action="view"
                                        path={`${AppNavPaths.TimeCharges}`}
                                        component={TimeCharge}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="timesheet"
                                        action="view"
                                        path={`${AppNavPaths.TimeOffRequests}`}
                                        component={TimeOffRequest}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="payroll"
                                        action="view"
                                        path={`${AppNavPaths.Payroll}`}
                                        component={PayrollIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="payroll"
                                        action="viewindividual"
                                        path={`${AppNavPaths.PayrollIndividual}`}
                                        component={PayrollIndividualIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="payroll"
                                        action="view"
                                        path={`${AppNavPaths.PayrollManagement}`}
                                        component={PayrollManagementIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="quickBooksInventoryItem"
                                        action="create"
                                        path={`${AppNavPaths.QuickBooksInventoryItem}`}
                                        component={
                                            QuickBooksInventoryItemsForm
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="quickBooksInventoryItem"
                                        action="view"
                                        path={`${AppNavPaths.QuickBooksInventoryItem}/:id`}
                                        component={
                                            QuickBooksInventoryItemsForm
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="quickBooksInventoryItem"
                                        action="view"
                                        path={`${AppNavPaths.QuickBooksInventoryItems}`}
                                        component={
                                            QuickBooksInventoryItemsIndex
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="contactactivity"
                                        action="view"
                                        path={`${AppNavPaths.ContactActivities}`}
                                        component={ContactActivityIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="call_disposition"
                                        action="view"
                                        path={`${AppNavPaths.CallDispositions}`}
                                        component={CallDispositionIndex}
                                    />
                                    <Route
                                        exact
                                        path={AppNavPaths.Unauthorized}
                                        component={NotAuthorizedPage}
                                    />
                                    <Route
                                        path={
                                            ApplicationPaths.ApiAuthorizationPrefix
                                        }
                                        component={ApiAuthorizationRoutes}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        path={`${AppNavPaths.NotFound}`}
                                        component={NotFound}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        path={`${AppNavPaths.ServerError}`}
                                        component={ServerError}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        path={`${AppNavPaths.NoPermission}`}
                                        component={NoPermission}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jobassignmentcancellationtype"
                                        action="view"
                                        path={`${AppNavPaths.JobAssignmentCancellationTypes}`}
                                        component={
                                            JobAssignmentCancellationTypeIndex
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billinggroup"
                                        action="view"
                                        path={`${AppNavPaths.CompanyBillingGroup}`}
                                        component={CompanyBillingGroupIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billinggroup"
                                        action="edit"
                                        path={`${AppNavPaths.CompanyBillingGroupNew}/:id`}
                                        component={CompanyBillingGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="billinggroup"
                                        action="create"
                                        path={`${AppNavPaths.CompanyBillingGroupNew}`}
                                        component={CompanyBillingGroupForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jobassignmentcancellationtype"
                                        action="view"
                                        path={`${AppNavPaths.PaySchedule}`}
                                        component={PayScheduleIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jobassignmentcancellationtype"
                                        action="create"
                                        path={`${AppNavPaths.PayScheduleNew}/:id`}
                                        component={PayScheduleForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jobassignmentcancellationtype"
                                        action="create"
                                        path={`${AppNavPaths.PayScheduleNew}`}
                                        component={PayScheduleForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="active_employee_list"
                                        action="view"
                                        path={AppNavPaths.ActiveEmployees}
                                        component={ActiveEmployeeListIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="collected_reporting"
                                        action="view"
                                        path={
                                            AppNavPaths.CollectedReporting
                                        }
                                        component={CollectedReportingIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="admintool"
                                        action="view"
                                        path={`${AppNavPaths.AdminTool}`}
                                        component={AdminToolIndex}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="admintool"
                                        action="view"
                                        path={`${AppNavPaths.AdminTool}/:id`}
                                        component={AdminTools}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="supporttool"
                                        action="view"
                                        path={`${AppNavPaths.SupportTools}`}
                                        component={SupportTools}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="supporttool"
                                        action="view"
                                        path={`${AppNavPaths.SupportTools}/:toolId`}
                                        component={SupportTools}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="county_group"
                                        action="view"
                                        path={`${AppNavPaths.USCountyGroups}`}
                                        component={USCountyGroupsIndex}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="county_group"
                                        action="create"
                                        path={`${AppNavPaths.USCountyGroupNew}`}
                                        component={USCountyGroupForm}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="county_group"
                                        action="edit"
                                        path={`${AppNavPaths.USCountyGroup}/:id`}
                                        component={USCountyGroupForm}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="county_group"
                                        action="view"
                                        path={`${AppNavPaths.USStates}`}
                                        component={USStates}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="county_group"
                                        action="edit"
                                        path={`${AppNavPaths.USState}/:id`}
                                        component={USStateForm}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="contract"
                                        action="view"
                                        path={`${AppNavPaths.Estimates}`}
                                        component={EstimateIndex}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="jot_form"
                                        action="view"
                                        path={`${AppNavPaths.JotForms}`}
                                        component={JotFormIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jot_form"
                                        action="create"
                                        path={`${AppNavPaths.JotFormNew}`}
                                        component={JotFormForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jot_form"
                                        action="edit"
                                        path={`${AppNavPaths.JotForm}/:id`}
                                        component={JotFormForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="certification"
                                        action="view"
                                        path={`${AppNavPaths.Certifications}`}
                                        component={CertificationIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="certification"
                                        action="creat"
                                        path={`${AppNavPaths.Certifications}`}
                                        component={CertificationForm}
                                    />
                                    <AuthorizeRoute
                                        path={`${AppNavPaths.JotFormThankYou}`}
                                        component={JotFormThankYou}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="equipment_tag"
                                        action="view"
                                        path={`${AppNavPaths.EquipmentTags}`}
                                        component={EquipmentTagIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="equipment_tag"
                                        action="create"
                                        path={`${AppNavPaths.EquipmentTagNew}`}
                                        component={EquipmentTagForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="equipment_tag"
                                        action="edit"
                                        path={`${AppNavPaths.EquipmentTag}/:id`}
                                        component={EquipmentTagForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="operational_category"
                                        action="view"
                                        path={`${AppNavPaths.OperationalCategories}`}
                                        component={OperationalCategoriesIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="operational_category"
                                        action="create"
                                        path={`${AppNavPaths.OperationalCategoryNew}`}
                                        component={OperationalCategoryForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="operational_category"
                                        action="edit"
                                        path={`${AppNavPaths.OperationalCategory}/:id`}
                                        component={OperationalCategoryForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="quick_sale"
                                        action="view"
                                        path={`${AppNavPaths.QuickSales}`}
                                        component={QuickSalesIndex}
                                    />

                                    <AuthorizeRoute
                                        exact
                                        perm="resourceKit"
                                        action="view"
                                        path={`${AppNavPaths.ResourceKits}`}
                                        component={ResourceKitIndex}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="resourceKit"
                                        action="view"
                                        path={`${AppNavPaths.ResourceKit}/:id`}
                                        component={ResourceKitForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="resourceKit"
                                        action="upsert"
                                        path={`${AppNavPaths.ResourceKitNew}`}
                                        component={ResourceKitForm}
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="nonflaggingtimesheet"
                                        action="create"
                                        path={`${AppNavPaths.TimeTracker}`}
                                        component={
                                            TimeTracker
                                        }
                                    />
                                    <AuthorizeRoute
                                        exact
                                        perm="jobType"
                                        action="view"
                                        path={`${AppNavPaths.JobTypes}`}
                                        component={JobTypeIndex}
                                    />
                                    <AuthorizeRoute component={NotFound} />
                                </Switch>
                            </Layout>
                        </AbilityContext.Provider>
                    );
                }}
            </CacheBuster>
        );
    }
}

const mapStateToProps = (state) => ({
    permissions: getAllPermissions(state),
    location: getLocation(state),
});

export default connect(mapStateToProps)(App);
